<div class="component-container flex flex-col justify-center items-center gap-y-[5rem]">
  <div
    *ngFor="let eachAdult of userDetails['adults']"
    class="each-adult-block flex flex-col justify-center items-center"
  >
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Adult Name
        </div>

        <div class="value w-3/5">
          {{eachAdult['firstName']}} {{eachAdult['lastName']}}
        </div>

      </div>

      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          LAR
        </div>

        <div class="value w-3/5">
          {{eachAdult['isLar'] ? 'Yes' : 'No'}}
        </div>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Phone Number
        </div>

        <div class="value w-3/5">
          {{eachAdult['phoneNumber']}}
        </div>

      </div>
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5" [class.label-edit]="isEditMode">
          Relationship
        </div>

        <div *ngIf="!isEditMode" class="value w-3/5"
             [class.relationship-value]="eachAdult['relation']?.key === 0"
             [title]="eachAdult['relation']?.key === 0 ? (eachAdult['relation']?.value || eachAdult['relation']) : ''">
          {{eachAdult['relation']?.value || eachAdult['relation']}}
        </div>

        <app-dropdown
          *ngIf="isEditMode && forms[eachAdult.id]"
          [loading]="relationshipFilterLoading"
          [options]="relationshipFilterList"
          [parentFormGroup]="forms[eachAdult.id]"
          class="dropdown-field w-3/5 min-w-[60%]"
          controlName="relation"
          placeholder="Select one"
          type="small"
        />

      </div>
    </div>
    <div
      *ngIf="isEditMode && forms[eachAdult.id]?.get('relation')?.value === 0"
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
      </div>
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5" [class.label-edit]="isEditMode">
          Other Text
        </div>

        <app-text-input
          [parentFormGroup]="forms[eachAdult.id]"
          class="dropdown-field w-3/5 min-w-[60%]"
          controlName="otherRelationText"
          placeholder="Enter relationship"
          type="small"
        ></app-text-input>

      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5">
          Email Address
        </div>

        <div class="value w-3/5">
          {{eachAdult['emailId'] }}
        </div>

      </div>
      <div class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

        <div class="label w-2/5" [class.label-edit]="isEditMode">
          Household
        </div>

        <div *ngIf="!isEditMode" class="value w-3/5">
          {{eachAdult?.household?.value || '-'}}
        </div>

        <app-dropdown
          *ngIf="isEditMode && forms[eachAdult.id]"
          [loading]="householdFilterLoading"
          [options]="householdFilterList"
          [parentFormGroup]="forms[eachAdult.id]"
          class="dropdown-field w-3/5 min-w-[60%]"
          controlName="household"
          placeholder="Select one"
          type="small"
        />

      </div>
    </div>
  </div>

  <div
    *ngIf="isEditMode"
    class="action-section flex flex-row
           justify-end items-center space-x-[1rem]"
  >
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!isAnyFormDirty"
      [isLoading]="isLoading"
      class="save-btn w-[8rem]"
      type="small"
    >
      Save
    </app-primary-button>
    <app-primary-button
      (handleClick)="close()"
      class="close-btn w-[8rem]"
      type="small"
    >
      Close
    </app-primary-button>
  </div>

  <div
    *ngIf="!isEditMode && loggedInUserRole !== roles['participant']"
    class="action-section flex flex-row
           justify-end items-center
           md:mr-[12rem] mr-[0] gap-[1.5rem]"
  >
    <app-primary-button
      (handleClick)="editAdultDetails()"
      class="edit-button w-[7.5rem]"
      type="small"
    >
      Edit
    </app-primary-button>
  </div>
</div>
